const isBrowser = typeof window !== 'undefined' && window !== null;
let L;

if (isBrowser) {
    L = require('leaflet');
}

export function createWmtsLayer(url, options = {}) {
  if (!L.TileLayer.WMTS) {
    L.TileLayer.WMTS = L.TileLayer.extend({
      defaultWmtsParams: {
        service: 'WMTS',
        request: 'GetTile',
        version: '1.0.0',
        layer: '',
        style: '',
        tilematrixSet: '',
        format: 'image/png'
      },

      initialize: function (url, options = {}) {
        const wmtsParams = { ...this.defaultWmtsParams };

        for (const key in options) {
          if (!(key in L.TileLayer.prototype.options)) {
            wmtsParams[key] = options[key];
          }
        }

        this._url = url;
        this.wmtsParams = wmtsParams;

        // Domyślny tileSize to 256 jeśli nie podano
        if (!options.tileSize) {
          options.tileSize = 256;
        }

        // Offset zoomu dla tileMatrix: jawny (wyliczony przez backend z GetCapabilities,
        // bo serwery roznie numeruja TileMatrix) albo heurystyka z tileSize (np. 512 => 1)
        this.zoomOffsetWmts = typeof options.wmtsZoomOffset === 'number'
          ? options.wmtsZoomOffset
          : Math.log2(options.tileSize) - 8;

        L.setOptions(this, options);
        L.TileLayer.prototype.initialize.call(this, url, options);
      },

      getTileUrl: function (coords) {
        const tileCol = coords.x;
        const tileRow = coords.y;
        const tileMatrix = this._tileZoom - this.zoomOffsetWmts;

        const baseUrl = `${this._url}${this.wmtsParams.layer}/`;

        if (this.wmtsParams.style) {
          return (
            `${baseUrl}${this.wmtsParams.style}/${this.wmtsParams.tilematrixSet}/` +
            `${tileMatrix}/${tileCol}/${tileRow}.png`
          );
        }

        return (
          `${baseUrl}${this.wmtsParams.tilematrixSet}/` +
          `${tileMatrix}/${tileCol}/${tileRow}.png`
        );
      }
    });
  }

  return new L.TileLayer.WMTS(url, options);
}



// WEBPACK FOOTER //
// src/components/utils/wmtsLayer.js